export default __webpack_public_path__ + "static/media/blog-5.52c679c3.jpg";